import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import type {
  ToastGuidGroup,
  CreateToastGuidGroupPayload,
} from '../types/toastGuidGroup';
import { toastGuidGroupQueryKeys } from './useToastGuidGroups';

export function useCreateToastGuidGroup(
  options?: UseMutationOptions<
    ToastGuidGroup,
    Error,
    CreateToastGuidGroupPayload
  >,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['toastGuidGroup', 'create'],
    mutationFn: async (payload: CreateToastGuidGroupPayload) => {
      return service.createToastGuidGroup(payload);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: toastGuidGroupQueryKeys.all });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
